import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MdwFade } from '@spaces-ui/animations/angular-css';
import {
  MdwAlertNotificationBase,
  MdwAlertNotificationsService,
} from '@spaces-ui/meadow/components/alert-notifications';
import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwNotificationsService } from '@spaces-ui/meadow/components/notifications';
import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Apple_Duotone } from '@spaces-ui/meadow/icons/svgs';
import { GuidUtils } from '@spaces-ui/utils';

import { Sample } from '../../components';

//#region sample:alertNotificationExample
@Component({
  selector: 'app-alert-notification',
  template: `
    <mdw-fade [isVisible]="animationState() === 'animated'" [verticalOffset]="8">
      <div
        [style.width.px]="400"
        class="pad-300 surface-elevated border-radius-200 vflex-200 flex-align-items-center"
      >
        <mdw-icon
          class="icon-callout x-large-callout icon-callout-teal"
          [icon]="icons.Apple_Duotone"
        ></mdw-icon>
        <p class="bold">{{ message }}</p>
        <div class="hflex-000 flex-align-items-center flex-justify-content-center">
          <button [style.width.px]="200" class="mdw-button mdw-primary" (click)="close()">
            {{ buttonCaption }}
          </button>
        </div>
      </div>
    </mdw-fade>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwIcon, MdwButton, MdwFade],
})
export class AlertNotificationComponent extends MdwAlertNotificationBase {
  public message?: string;
  public buttonCaption?: string;
  public icons = { Apple_Duotone };
}
//#endregion

//#region sample:alertNotificationExample
@Component({
  selector: 'app-notifications',
  imports: [Sample, MdwButton],
  templateUrl: './notifications.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './notifications.scss',
})
export class Notifications {
  //#endregion
  //#region sample:successExample|errorExample
  private notificationService = inject(MdwNotificationsService);
  //#endregion

  //#region sample:alertNotificationExample
  private alertNotificationsService = inject(MdwAlertNotificationsService);
  //#endregion

  //#region sample:errorExample
  public showError() {
    this.notificationService.showError('This is an error notification!', 'Error message');
  }
  //#endregion

  //#region sample:successExample
  public showSuccess() {
    this.notificationService.showSuccess('This is a success notification!');
  }
  //#endregion

  //#region sample:alertNotificationExample
  public showTopAlert() {
    const id = GuidUtils.createGuid();
    this.alertNotificationsService.showTopAlert(id, AlertNotificationComponent, {
      message: 'Apple Found!',
      buttonCaption: 'Cool!',
    });
  }

  public showBottomAlert() {
    const id = GuidUtils.createGuid();
    this.alertNotificationsService.showBottomAlert(id, AlertNotificationComponent, {
      message: 'Apple Found!',
      buttonCaption: 'Cool!',
    });
  }
  //#endregion

  //#region sample:alertNotificationExample
}
//#endregion
